import React, { useEffect, useRef, useState } from "react";
import { AUTH_STORAGE_KEY } from "../socket";
// import ServiceAddForm from '../components/ServiceAddForm';

function ProfilePage() {
  const avatarRef = useRef();
  const coverRef = useRef();

  const [profile, setProfile] = useState({
    fullName: "",
    mobileNumber: "",
    profileImageUrl: "",
    coverImageUrl: "",
    email: ""
  });

  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  const raw = localStorage.getItem(AUTH_STORAGE_KEY);
  const parsed = raw ? JSON.parse(raw) : null;
  const token = parsed?.token;

  useEffect(() => {
    fetch("/api/profile", {
      headers: { Authorization: "Bearer " + token }
    })
      .then(res => res.json())
      .then(data =>
        setProfile({
          ...data,
          coverImageUrl: data.coverImageUrl || ""
        })
      );
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile(prev => ({ ...prev, [name]: value }));
  };
  

  const handleSave = async () => {
    setSaving(true);

    const res = await fetch("/api/profile", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      },
      body: JSON.stringify(profile)
    });

    const data = await res.json();
    setSaving(false);

    if (data.success) setProfile(data.user);
  };

  const handleAvatar = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("avatar", file);

  const res = await fetch("/api/profile/avatar", {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: formData,
  });

  const data = await res.json();

  if (data.success) {
    setProfile(prev => ({
      ...prev,
      profileImageUrl: data.profileImageUrl
    }));
  }
};

const handleCover = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("cover", file);

  try {
    const res = await fetch("/api/profile/cover", {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    });

    const data = await res.json();

    if (data.success) {
      setProfile(prev => ({
        ...prev,
        coverImageUrl: data.coverImageUrl
      }));
    }
  } catch (err) {
    console.error(err);
  }
};

  return (
    <div className="profile-top">

     <div className="profile-cover-top">

  <img
    src={profile.coverImageUrl}
    alt="cover"
  />

  <button
    type="button"
    className="cover-edit-btn"
    onClick={() => coverRef.current?.click()}
  >
    Edit Cover
  </button>

  <input
    ref={coverRef}
    type="file"
    hidden
    onChange={handleCover}
  />

</div>
      {/* AVATAR */}
      <div className="profile-avatar-top">
        <img src={profile.profileImageUrl || "/default-avatar.png"} />

        <button onClick={() => avatarRef.current.click()}>
          Edit
        </button>

        <input
          ref={avatarRef}
          type="file"
          hidden
          onChange={handleAvatar}
        />
      </div>

      {/* NAME */}
      <div className="profile-name">
        <h3>{profile.fullName}</h3>
       <p>{profile.email || "No Email"}</p>
      </div>

      {/* FORM */}
      <div className="profile-form-card">

        <div className="profile-field">
          <label>Full Name</label>
          <input
            name="fullName"
            value={profile.fullName}
            onChange={handleChange}
          />
        </div>

        <div className="profile-field">
          <label>Mobile</label>
          <input
            name="mobileNumber"
            value={profile.mobileNumber}
            onChange={handleChange}
          />
        </div>

        <button className="save-btn" onClick={handleSave}>
          {saving ? "Saving..." : "Save Changes"}
        </button>

      </div>


    </div>
  );
}

export default ProfilePage;